import { render, staticRenderFns } from "./baiguullaga.vue?vue&type=template&id=8a745172&"
import script from "./baiguullaga.vue?vue&type=script&lang=js&"
export * from "./baiguullaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports